import { render, staticRenderFns } from "./changeDelivary.vue?vue&type=template&id=511da3dd"
import script from "./changeDelivary.vue?vue&type=script&lang=js"
export * from "./changeDelivary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports